/* @ngInject */
function ProfileSocialAccountsController ($scope, $rootScope, $state, $timeout, $translate, CONSTANTS, Utils, UserService, MessageService, ToastService) {
  $timeout(function () {
    $('.sync-facebook-btn').popup()
  }, 0, false)

  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId

  $scope.aFacebookProfiles = []
  // $scope.aFacebookPages = [];
  $scope.aTwitterProfiles = []
  $scope.aLinkedinProfiles = []
  $scope.bShowFacebookButton = false
  $scope.bShowTwitterButton = false
  $scope.bShowLinkedinButton = false

  $scope.delete = function (sId) {
    UserService.removeSocialAccount({
      externalId: sId
    })
      .then(function (oResult) {
        return $scope.loadSocialAccounts()
      })
      .catch(ToastService.defaultErrorToast)
  }

  $scope.connect = function (sMediaName) {
    if (sMediaName === 'facebook') {
      MessageService.warning({
        title: 'beware',
        text: 'fbPageLinkWarn',
        confirmButton: 'yes',
        cancelButton: 'no',
        closeOnConfirm: true,
        press: function () {
          window.location.href = $rootScope.URL_BACKEND + '/Authentication/' + sMediaName + '/authorize'
        }
      })
    } else {
      window.location.href = $rootScope.URL_BACKEND + '/Authentication/' + sMediaName + '/authorize'
    }
  }

  $scope.resync = function (sType) {
    UserService.resyncSocialAccounts({
      type: sType
    })
      .then(function (oResult) {
        if (!oResult.length) {
          ToastService.showErrorToast($translate.instant('noPagesFbSync'))
          return
        }
        return $scope.loadSocialAccounts()
      })
      .catch(ToastService.defaultErrorToast)
  }

  $scope.loadSocialAccounts = function () {
    return UserService.getSocialAccounts()
      .then(function (aSocialAccounts) {
        $scope.aFacebookProfiles.length = 0 // Clean arrays
        $scope.aTwitterProfiles.length = 0
        $scope.aLinkedinProfiles.length = 0

        aSocialAccounts.forEach(function (oSocialAccount) {
          if (oSocialAccount.type === 'FACEBOOK') {
            oSocialAccount.img = Utils.fnReplaceStringParams(CONSTANTS.FACEBOOK_PROFILE_PIC_URL, [oSocialAccount.externalId])
            $scope.aFacebookProfiles.push(oSocialAccount)
          } else if (oSocialAccount.type === 'TWITTER') {
            oSocialAccount.img = oSocialAccount.profilePicture
            $scope.aTwitterProfiles.push(oSocialAccount)
          } else if (oSocialAccount.type === 'LINKEDIN') {
            oSocialAccount.img = oSocialAccount.profilePicture
            $scope.aLinkedinProfiles.push(oSocialAccount)
          }
        })

        $scope.bShowFacebookButton = $scope.aFacebookProfiles.length === 0
        $scope.bShowTwitterButton = $scope.aTwitterProfiles.length === 0
        $scope.bShowLinkedinButton = $scope.aLinkedinProfiles.length === 0
      })
  }
  // Load
  $scope.loadSocialAccounts()
}

export { ProfileSocialAccountsController }
